











import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import ChatComponent from "@share/chat/components/ChatComponent.vue";
import { EventBus } from "@common/EventBus";
import AnalyticsMixin from "../../mixins/AnalyticsMixin";

import ChatExport from "@share/chat-export/components/ChatExport.vue";

@Component({
    name: 'ChatView',
    components: { ChatComponent, ChatExport }
})
export default class ChatView extends Mixins(AnalyticsMixin) {
    @Prop({ default: false }) isShowing: boolean;

    eventRoomId: string | null = null;
    openEventRoom = false;
    showExportModal = false;
    comingRouteData = { name: "", params: { backend: ''}}

    from = {};

    async mounted() {
        const eventChatParams = this.$store.getters['events/selectedEventViewParam']('chat', null);

        if (eventChatParams && eventChatParams.eventChatId && eventChatParams.eventChatId.id) {
            this.eventRoomId = eventChatParams.eventChatId.id;
            this.openEventRoom = !!eventChatParams.eventChatId.autoOpen;
            this.$store.commit('chat/groups/setPinnedRoomIds', [this.eventRoomId]);

            //Если мы уже не открываем какой-то определенный чат
            if (this.openEventRoom && document.location.hash.length < 2) {
                await this.$store.dispatch('chat/groups/fetchData');
                EventBus.$emit('openChatRoom', this.eventRoomId);
            }
        }
        this.$store.commit('setShowChat', true);

        //NOTE: можно убрать eventBus
        EventBus.$on('chat/openExport', this.openChatExportModal);
    }

    /**
     * closing the current view completely
     */
    closeView() {
        if(!this.comingRouteData.params.backend) {
            this.comingRouteData.params.backend = this.$route.params?.backend;
        }
        this.$router.push({name: this.comingRouteData.name, params: this.comingRouteData.params})
    }

    openChatExportModal() {
        this.showExportModal = true;
    }

    activated() {

        if(this.$route.meta?.from?.name && this.$route.meta?.from?.name !== "Chat") {
            this.comingRouteData = { name: this.$route.meta?.from?.name || '', params: this.$route.meta?.from?.params || {} }
        }
        else if(!this.$route.meta?.from?.name) {
            this.comingRouteData = { name: "Home", params: { backend: this.$route.params?.backend } }
        }

        this.$store.commit('setShowChat', true);

        this.$nextTick(() => {
            const input = document.querySelector('#chat-input') as HTMLElement;
            input && input.focus();
        });

        this.sendScreenView('Chat');
    }

    deactivated() {
        this.$store.commit('setShowChat', false);
    }
}
